import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export const CK_EDITOR: any = ClassicEditor;
export const CK_EDITOR_CONFIG = {
  toolbar: [
    'heading', '|',
    'bold', 'italic', '|',
    'link', '|',
    'styles', '|',
    'bulletedList', 'numberedList', '|',
    'undo', 'redo'
  ],
  height: '400px'
}
